import { render, staticRenderFns } from "./PageLink.vue?vue&type=template&id=21efaa06&scoped=true&"
import script from "./PageLink.vue?vue&type=script&lang=js&"
export * from "./PageLink.vue?vue&type=script&lang=js&"
import style0 from "./PageLink.vue?vue&type=style&index=0&id=21efaa06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21efaa06",
  null
  
)

export default component.exports